<template>
	<v-card>
		<v-card-title class="d-flex align-center">
			<v-icon
				icon="$shoppingCart"
				start
			/>
			<translate>
				Order Reference
			</translate>
		</v-card-title>
		<v-card-text>
			<div v-if="orderReference">
				<div v-if="/^\d{9,12}$/.test(orderReference)">
					<v-row
						v-for="item in items"
						:key="item.text"
						dense
					>
						<v-col>
							<v-btn
								variant="flat"
								color="belsimpel"
								target="_blank"
								:href="item.link"
							>
								<v-img
									height="32"
									width="32"
									src="/bo/images/belsimpel-228x228.png"
									class="rounded-lg"
								/>
                            &nbsp;
								{{ item.text }}
							</v-btn>
						</v-col>
					</v-row>
				</div>
				<div v-else>
					<translate>Order Reference</translate> # {{ orderReference }}
				</div>
				<v-row
					dense
				>
					<v-col>
						<v-spacer />

						<copy-to-clipboard-button
							:copy-data="orderReference"
							variant="flat"
							color="primary"
						>
							<translate>Copy reference number</translate>
						</copy-to-clipboard-button>
					</v-col>
				</v-row>
			</div>
			<v-row
				v-if="claimIdentifier"
				dense
			>
				<v-col>
					<v-spacer />
					<copy-to-clipboard-button
						:copy-data="claimIdentifier"
						variant="flat"
						color="primary"
					>
						<translate>Copy claim number</translate>
					</copy-to-clipboard-button>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
export default {
	name: 'OrderReferenceCard',
	props: {
		orderReference: {
			required: false,
			type: String,
			default: null
		},
		claimIdentifier: {
			required: false,
			type: String,
			default: null
		}
	},
	data () {
		return {
			items:
				[
					{
						text: this.$gettext('Alice') + `# ${this.orderReference}`, link: `https://alice.belsimpel.nl/order/detail/${this.orderReference}`
					},
					{
						text: this.$gettext('Alice Invoice'), link: `https://alice.belsimpel.nl/order/download/invoice/${this.orderReference}/${this.orderReference}`
					},
					{
						text: this.$gettext('BO2') + `# ${this.orderReference}`, link: `https://www.belsimpel.nl/bo2/retouren?identifier=&orderkey=${this.orderReference}`
					},
				]
		};
	}
};
</script>
